
define('tmpl!core/templates/webidl/enum.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlEnum\' id=\'idl-def-{{obj.refId}}\'>{{extAttr obj indent true\n}}{{idn indent}}enum <span class=\'idlEnumID\'>{{obj.id}}</span> &#123;\n{{{children}}}{{idn indent}}\n&#125;;');});

